"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgMenuKebab(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "10 -4 4 24" }, props),
        React.createElement("path", { d: "M12 12a2 2 0 110 4 2 2 0 010-4zm0-6a2 2 0 110 4 2 2 0 010-4zm0-6a2 2 0 110 4 2 2 0 010-4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('MenuKebab')(SvgMenuKebab);
//# sourceMappingURL=MenuKebab.js.map